<template>
  <div class="chooseModuleMenu">
    <router-link
      v-if="canSeeClinicAgenda"
      :to="{ path: '/calendar-page', query: { mode: 'clinic' } }"
      custom
      v-slot="{ navigate }"
    >
      <button
        class="module-btn"
        :class="{ 'module-btn--active': isSelected('clinic') }"
        @click="navigate"
      >
        Agenda Clínica
      </button>
    </router-link>

    <router-link
      v-if="canSeeDoctorAgenda"
      :to="{ path: '/calendar-page', query: { mode: 'doctor' } }"
      custom
      v-slot="{ navigate }"
    >
      <button
        class="module-btn"
        :class="{ 'module-btn--active': isSelected('doctor') }"
        @click="navigate"
      >
        Agenda Médico
      </button>
    </router-link>

    <router-link to="/patients-page" custom v-slot="{ navigate }">
      <button
        class="module-btn"
        :class="{ 'module-btn--active': isSelected('patients') }"
        @click="navigate"
      >
        Pacientes
      </button>
    </router-link>
  </div>
</template>

<script>
export default {
  name: "ChooseModuleMenu",

  computed: {
    userType() {
      return this.$store.getters["auth/userType"];
    },
    canSeeClinicAgenda() {
      return this.userType === "assistant" || this.userType === "doctor_clinic";
    },
    canSeeDoctorAgenda() {
      return (
        this.userType === "doctor_clinic" || this.userType === "doctor_solo"
      );
    },
  },

  watch: {
    userType: {
      handler() {
        this.ensureValidRouteForUserType();
      },
      immediate: true,
    },
    $route: {
      handler() {
        this.ensureValidRouteForUserType();
      },
      deep: true,
    },
  },

  methods: {
    isSelected(mode) {
      if (mode === "patients") return this.$route.path === "/patients-page";
      return (
        this.$route.path === "/calendar-page" &&
        (this.$route.query.mode || "doctor") === mode
      );
    },

    ensureValidRouteForUserType() {
      if (this.$route.path !== "/calendar-page") return;

      const mode = this.$route.query.mode || "doctor";

      if (this.userType === "assistant" && mode !== "clinic") {
        return this.$router.replace({
          path: "/calendar-page",
          query: { mode: "clinic" },
        });
      }
      if (this.userType === "doctor_solo" && mode !== "doctor") {
        return this.$router.replace({
          path: "/calendar-page",
          query: { mode: "doctor" },
        });
      }
      if (
        !["assistant", "doctor_solo", "doctor_clinic"].includes(this.userType)
      ) {
        return this.$router.replace({ path: "/patients-page" });
      }
    },
  },
};
</script>

<style scoped>
.chooseModuleMenu {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-right: 16px;
}

.module-btn {
  padding: 6px 16px;
  font-size: 13px;
  font-weight: 500;
  border: 1.5px solid var(--ds-blgrey-100);
  border-radius: 20px;
  background: transparent;
  cursor: pointer;
  white-space: nowrap;
  transition: background-color 0.15s ease, border-color 0.15s ease,
    color 0.15s ease, box-shadow 0.15s ease;
  color: var(--ds-text-550);
  letter-spacing: 0.2px;
}

.module-btn:hover {
  background-color: var(--ds-blue-bg);
  border-color: var(--ds-text-muted);
  color: var(--ds-text-700);
}

.module-btn--active {
  background-color: var(--ds-blue-100);
  border-color: var(--ds-primary);
  color: var(--ds-primary);
  font-weight: 700;
  box-shadow: 0 2px 6px rgba(31, 77, 63, 0.18);
}

.module-btn--active:hover {
  background-color: #d6e9fa;
  border-color: var(--ds-primary-dark);
  color: var(--ds-primary-dark);
}
</style>
